import _ from 'underscore';
import { useCallback } from 'react';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const postEventLog = (cid, aid, postData) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)['Default.PostABTestingEventLog']
  .$makeCall({
    payload: { data: postData },
  })
  .toPromise();

export function useStepFlowEvent(
  serverContext,
  logTrace = _.noop
) {
  const accountId = _.get(serverContext, ['CurrentAccount', 'Id']);
  const customerId = _.get(serverContext, ['CurrentCustomer', 'Id']);
  const { token } = serverContext;

  const postEvent = useCallback(({ EventName, EventValue }) => {
    const data = {
      UniqueId: _.get(serverContext, ['Omniture', 'SessionId']),
      EventName,
      EventValue: JSON.stringify({
        AID: accountId,
        CID: customerId,
        ...EventValue,
        TimeStamp: new Date().toISOString(),
      }),
    };
    logTrace(`[PostABTestingEventLog]: UniqueId: ${data.UniqueId}, EventName: ${data.EventName}, EventValue: ${data.EventValue}`);

    postEventLog(customerId, accountId, data, token);
  }, [serverContext, accountId, customerId, logTrace, token]);

  return postEvent;
}
